import Crud from '../components/Tickets/Crud'
import Manage from '../components/Tickets/Manage'

let routes = {
    path: '/tickets',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/tickets',
            name: 'Chamados Abertos',
            component: Crud
        },
        {
            path: '/tickets/manage/:id?',
            name: 'Gerenciamento de Chamado',
            component: Manage
        },
    ]
};

export default routes


// WEBPACK FOOTER //
// ./src/router/tickets.js